import { Button } from '@heathmont/moon-core-tw';
import ControlsVerticalDoubleChevron from '@/external/icons/ControlsVerticalDoubleChevron';

type Props = {
  onClick?: () => void;
  fullWidth?: boolean;
};

const IconButton: FC<Props> = ({ children, onClick, fullWidth }) => (
  <Button
    className="justify-between font-normal text-trunks md:min-w-[11.25rem] ring-beerus"
    size="lg"
    iconRight={
      <ControlsVerticalDoubleChevron className="text-moon-24 text-trunks" />
    }
    onClick={onClick}
    fullWidth={fullWidth}
    variant="secondary"
  >
    {children}
  </Button>
);

export default IconButton;
